import { State, Selector, StateContext, Action, Store } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { PlaceOrder, OrderResponse, Venue } from '../models';
import {
  SetOrder,
  ClearOrderResponseMessage,
  SetOrderDetails,
  changeShowStatus,
  fromOrderSuccess,
  ChangeCategory,
  ClearDeals,
  FetchMealCodePayment
} from '../actions';
import { VenueManagementState } from './venue-management.state';
import { WhitelabelState } from './whitelabel.state';
import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { OrderService, VenueManagementService,SharedService } from '../services';
import { throwError } from 'rxjs';
import { LocationState } from './location.state';

export class OrderStateModel {
  orderDetails: any;
  placeOrder: PlaceOrder;
  orderResponse: OrderResponse;
  showOrderStatus: boolean;
  isFromOrderSuccess: boolean;
  mealCodePayment: any;
}

@State<OrderStateModel>({
  name: 'order',
  defaults: {
    orderDetails: null,
    placeOrder: {
      pushNotification: {
        key: '',
        icon: '',
        click_action: '',
      },
      paymentType: '',
      locationId: '',
      order: {
        orderVia: '',
        orderedBy: {
          guest: false,
          name: '',
          phone: '',
          userId: '',
          email: '',
        },
        orderLater: false,
        cartId: '',
        organizationId: '',
        locationId: '',
        specialInstructions: '',
        deliveryMethod: '',
        deliveryTime: '',
        deliveryAddress: {
          instructions: '',
          buzzerNumber: '',
          unitNumber: '',
          postalcode: '',
          country: '',
          state: '',
          city: '',
          streetAddress: '',
          _id: '',
          loc: [],
          addressType: '',
          deliverable: false,
          distance: '',
          regionCode : '',
        },
      },
      ackrooPaymentOrder: undefined,
      additionalParams: null,
      timeInfo: {
        locationId: '',
        type: '',
        currentTime: '',
        future: '',
        timezoneOffset: 0,
        selectedTime: '',
      },
      mealProgramOrder: null,
      zeroPaymentOrder : undefined,
    },
    orderResponse: {
      msg: '',
      orderNumber: '',
      order_id: '',
      status: 0,
      message: '',
      errorCode: '',
      unAvailableItems:undefined
    },
    showOrderStatus: false,
    isFromOrderSuccess: false,
    mealCodePayment: false
  },
})
@Injectable()
export class OrderState {
  constructor(
    private orderService: OrderService,
    private store: Store,
    private _venue: VenueManagementService,
    private shared:SharedService
  ) {}

  @Selector()
  static getOrderResponse(state: OrderStateModel) {
    return state.orderResponse;
  }
  @Selector()
  static getOrderDetails(state: OrderStateModel) {
    return state.orderDetails;
  }
  @Selector()
  static getShowstatus(state: OrderStateModel) {
    return state.showOrderStatus;
  }
  @Selector()
  static getOrderSuccess(state: OrderStateModel) {
    return state.isFromOrderSuccess;
  }
  @Selector()
  static mealCodePayment(state: OrderStateModel) {
    return state.mealCodePayment;
  }

  @Action(SetOrder)
  SetOrder(
    { patchState }: StateContext<OrderStateModel>,
    { payload }: SetOrder
  ) {
    const qrScanDetails = this.store.selectSnapshot(WhitelabelState.getQRScanDetails);
    const selectedLocation = this.store.selectSnapshot(LocationState.getSelectedLocation);
    if(qrScanDetails?.venueName && payload.order.deliveryMethod == qrScanDetails.deliveryType && selectedLocation?._id == qrScanDetails.locationId){
      payload.order['qrScanDetails'] = qrScanDetails;;
    }
    if (
      payload?.order?.deliveryMethod &&
      (payload.order.deliveryMethod == 'DELIVERYTYPE03' ||
        payload.order.deliveryMethod == 'DELIVERYTYPE08' ||
        payload.order.deliveryMethod == 'DELIVERYTYPE09' ||
        payload.order.deliveryMethod == 'DELIVERYTYPE10') ||
        (qrScanDetails?.venueName && payload.order.deliveryMethod == qrScanDetails.deliveryType && selectedLocation?._id == qrScanDetails.locationId)
    ) {
      payload.order['table'] = this.setVenueData(payload.order.deliveryMethod);
    }
    return this.orderService.placeOrder(payload).pipe(
      tap((response) => {
        if (response) {
          patchState({
            orderResponse: response,
          });
          if (response.status == 1) {
            this.orderService.clearCurrentCart(
              payload.locationId,
              payload.order.cartId
            );
            this.store.dispatch(new ChangeCategory(null));
            this.store.dispatch(new ClearDeals());
          } else if(response['errorCode'] == '1500'){
            this.shared.forceClearCart(response);
          }
        } else throw response;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  setVenueData(deliveryMethodTextCode) {
    let selectedVenue: Venue;
    selectedVenue = this.getVenueByDeliveryTypeTextCode(deliveryMethodTextCode);
    let venue = undefined;
    if (selectedVenue) {
      venue = {
        _id: selectedVenue._id,
        name: selectedVenue.name,
        guestCount: selectedVenue.guestCount ? selectedVenue.guestCount : undefined,
        type: selectedVenue.type ? selectedVenue.type['_id'] : undefined,
        allowSchedule : selectedVenue.allowSchedule ? selectedVenue.allowSchedule : undefined 
      };
    }
    return venue;
  }

  getVenueByDeliveryTypeTextCode(deliveryType) {
    let selectedVenue;
    const qrScanDetails = this.store.selectSnapshot(WhitelabelState.getQRScanDetails);
    const selectedLocation = this.store.selectSnapshot(LocationState.getSelectedLocation);
    if(qrScanDetails?.venueName && deliveryType == qrScanDetails.deliveryType && selectedLocation?._id == qrScanDetails.locationId){
      selectedVenue = this.store.selectSnapshot(
        VenueManagementState.getSelectedVenue
      );
    } else {
    switch (deliveryType) {
      case 'DELIVERYTYPE08':
        selectedVenue = this.store.selectSnapshot(
          VenueManagementState.getSelectedVenue
        );
        break;
      case 'DELIVERYTYPE09':
        selectedVenue = this.store.selectSnapshot(
          VenueManagementState.getSelectedPickUpLocation
        );
        break;
      case 'DELIVERYTYPE10':
        selectedVenue = this.store.selectSnapshot(
          VenueManagementState.getSelectedRoom
        );
        break;
      default:
        break;
    }
   }
    return selectedVenue;
  }

  @Action(SetOrderDetails)
  SetOrderDetails({ patchState }: StateContext<OrderStateModel>, { payload }) {
    patchState({
      orderDetails: payload,
    });
  }

  @Action(ClearOrderResponseMessage)
  ClearOrderResponseMessage(
    { getState, patchState }: StateContext<OrderStateModel>,
    {}: ClearOrderResponseMessage
  ) {
    patchState({
      orderResponse: {
        msg: '',
        orderNumber: '',
        order_id: '',
        status: 0,
        message: '',
        errorCode: '',
      },
    });
  }

  @Action(changeShowStatus)
  changeShowStatus(
    { setState }: StateContext<OrderStateModel>,
    { payload }: changeShowStatus
  ) {
    setState(
      patch({
        showOrderStatus: payload,
      })
    );
  }
  @Action(fromOrderSuccess)
  fromOrderSuccess(
    { setState }: StateContext<OrderStateModel>,
    { payload }: fromOrderSuccess
  ) {
    setState(
      patch({
        isFromOrderSuccess: payload,
      })
    );
  }

  @Action(FetchMealCodePayment)
  fetchMealCodeCart(
    { getState, patchState }: StateContext<OrderStateModel>) {
      const currentCart = this.store.selectSnapshot(
        (app) => app.cart.cart
      );
    const cartId = currentCart?currentCart.cart_id : undefined
    // const cartId = cart.cart_id;
    patchState({
      mealCodePayment: 'loading',
    });
    return this.orderService.getMealCodeCart(cartId).pipe(tap( cartData => {
      patchState({
        mealCodePayment: cartData,
      });
    }));;
  }
}
